import { FilterType } from '@/coreDomainsModule/entities/filter';
import { DATE_RANGE_FILTER_TYPES } from '@/coreDomainsModule/constants';

/**
 * フィルターモーダルのタイプ
 */
export type FilterModalType =
  | 'customerForecast'
  | 'supplierForecast'
  | 'order'
  | 'order-calendar'
  | 'orderControl'
  | 'inventory'
  | 'deletion-business'
  | 'unmanagedBusinessTypeAnnounce'
  | 'unmanagedBusinessTypeSalesResult'
  | 'unmanagedBusinessTypeInventory'
  | 'unmanagedBusinessTypeArrival'
  | 'editIndividualBusiness'
  | 'inventoryDashboard'
  | 'inventoryDashboardDetailAgg'
  | 'inventoryDashboardDetailBase'
  | 'unmatchedOrder';

/**
 * 詳細フィルターモーダルの状態管理
 * @param filterItems - フィルター項目の情報
 * @param currentFilterType - 現在選択肢を表示しているフィルタータイプ（排他制御に使用）
 */
export interface FilterModalState {
  filterItems: FilterContentItem[];
  currentFilterType?: FilterType;
}

/**
 * フィルターに使用する項目の情報
 * @param filterType - フィルタ項目のキー
 * @param selectedValue - 選択された値
 * @param label - ラベル
 */
export interface FilterContentItem {
  filterType: FilterType;
  selectedValue: string[];
  label: string;
  i18nOptions?: Record<string, string>;
  includeNull?: boolean;
}

/**
 * フィルターモーダルで使用した内容を管理
 * @param selectionFilterItems - selectInputで指定するフィルター項目の情報
 */
export interface FilterModalItems {
  selectionFilterItems: FilterContentItem[];
}

/**
 * フィルタータイプが日付範囲フィルターかどうかを判定する
 * @param filterType - フィルタータイプ
 */
export const isDateRangeFilterType = (filterType: FilterType): boolean => {
  return (DATE_RANGE_FILTER_TYPES as readonly string[]).includes(filterType);
};
